export enum TRAINING_ENTRY {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=445899578
     */
    PICKER_TITLE = 'TRAINING_ENTRIES.PICKER_TITLE',
}
